__turbopack_context__.v({
  "backIcon": "CategoryNav-module-scss-module__yxNbPG__backIcon",
  "backLink": "CategoryNav-module-scss-module__yxNbPG__backLink",
  "backLinks": "CategoryNav-module-scss-module__yxNbPG__backLinks",
  "categoryNav": "CategoryNav-module-scss-module__yxNbPG__categoryNav",
  "currentGroup": "CategoryNav-module-scss-module__yxNbPG__currentGroup",
  "currentLabel": "CategoryNav-module-scss-module__yxNbPG__currentLabel",
  "subcategories": "CategoryNav-module-scss-module__yxNbPG__subcategories",
  "subcategoryCount": "CategoryNav-module-scss-module__yxNbPG__subcategoryCount",
  "subcategoryLabel": "CategoryNav-module-scss-module__yxNbPG__subcategoryLabel",
  "subcategoryLink": "CategoryNav-module-scss-module__yxNbPG__subcategoryLink",
  "subcategoryList": "CategoryNav-module-scss-module__yxNbPG__subcategoryList",
});
